class ContactForm {
  body;
  trigger;
  target;
  banner;
  targetBtnHeader;
  triggerLogo;
  logoVisible: boolean = false;
  isHomePage;

  constructor() {
    this.body = document.querySelector('body');
    this.trigger = document.querySelectorAll('[data-trigger="contact-form"]');
    this.target = document.querySelector('[data-target="contact-form"]');
    this.targetBtnHeader = document.querySelector(
      '[data-trigger="contact-btn"]'
    );
    // this.banner = document.querySelector(
    //   '[data-trigger="header-primary-banner"]'
    // );
    if (this.target) {
      this._init();
    }
  }

  _init() {
    for (let index = 0; index < this.trigger.length; index++) {
      const element = this.trigger[index];
      element.addEventListener('click', (event) => {
        this._toggleNav(event);
      });
    }

    // close menu if you click on body
    this.body?.addEventListener('click', (event) => {
      if (this.body?.getAttribute('data-state') == 'locked-for-header-primary')
        this._closeMenu();
    });
    this.targetBtnHeader?.addEventListener('click', (event) => {
      if (this.body?.getAttribute('data-state') == 'locked-for-header-primary')
        this._closeMenu();
    });

    // No close menu if you click on it
    // this.target?.addEventListener('click', (event) => {
    //   event.stopPropagation();
    // });
    // this.banner?.addEventListener('click', (event) => {
    //   event.stopPropagation();
    // });

    window.addEventListener(
      'resize',
      (event) => {
        if (
          window.innerWidth >= 1025 &&
          this.body?.getAttribute('data-state') == 'locked-for-header-primary'
        ) {
          this._closeMenu();
        }
      },
      true
    );
  }

  _toggleNav(event: any) {
    // this._toggleState(this.body, 'locked-for-header-primary', 'unlocked');
    this._toggleState(this.target, 'open', 'closed');
    // this._toggleState(event.currentTarget, 'open', 'closed');
    this._toggleState(this.banner, 'open', 'closed');
    console.log('toggle');
  }

  _toggleState(elem: Element | null, one: string, two: string) {
    if (elem) {
      const newState = elem.getAttribute('data-state') === one ? two : one;
      elem.setAttribute('data-state', newState);
    }
  }

  _closeMenu() {
    // this._toggleState(this.body, 'locked-for-header-primary', 'unlocked');
    this._toggleState(this.target, 'open', 'closed');
    this._toggleState(this.banner, 'open', 'closed');
  }
}

export let contactForm = new ContactForm();
